import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './FBRightPreview.scss';
var FBRightPreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FBRightPreview, _Component);

  var _super = _createSuper(FBRightPreview);

  function FBRightPreview(props) {
    _classCallCheck(this, FBRightPreview);

    return _super.call(this, props);
  }

  _createClass(FBRightPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          adType = _this$props.adType;
      var paddingBottom = '53%';

      if (adType === 'pageLikes') {
        paddingBottom = '37%';
      }

      var style = {
        paddingBottom: paddingBottom
      };

      if (this.props.formatType === 'image') {
        style.backgroundImage = adDetails['image-ad-upload'] && adDetails['image-ad-upload'][0] ? "url(".concat(adDetails['image-ad-upload'][0], ")") : 'url(https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg)';
      } else {// TODO video display here
      }

      return /*#__PURE__*/React.createElement("div", null, this.props.formatType === 'carousel' || this.props.formatType === 'video' ? /*#__PURE__*/React.createElement("div", {
        className: styles.unSupportedType
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.unSupportedText
      }, "This ad format is not currently supported on the right column")) : /*#__PURE__*/React.createElement("div", {
        className: styles.mobilePreview
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.img,
        style: style
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.title
      }, /*#__PURE__*/React.createElement("strong", null, this.props.fbAcct.username)), /*#__PURE__*/React.createElement("div", {
        className: styles.subTitle
      }, adDetails.headline), /*#__PURE__*/React.createElement("div", {
        className: styles.description
      }, adDetails.description)), this.props.adType === 'pageLikes' ? /*#__PURE__*/React.createElement("div", {
        className: styles.fbButtonWrap
      }, /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, "Like Page")) : /*#__PURE__*/React.createElement("div", {
        className: styles.fbButtonWrap
      }, /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, "Learn More"))));
    }
  }]);

  return FBRightPreview;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired
}), _temp)) || _class);
export default FBRightPreview;